import {makeRequest, makeRequestPut, makeRequestGet} from '../../Services/API';

export function gravarReuniao(reuniao, language = 'POR') {
    return makeRequest(
        `/backend/negocios/reunioes/guardar/${language}`,
        reuniao,
    );
}

export function getReuniao(reuniao, language = 'POR') {
    return makeRequestGet(`/backend/negocios/reuniao/${reuniao}/${language}`);
}
